module.exports = __webpack_public_path__ + "28dd5cf2fb945f7ccf4aaf2c39188af0.svg";